
import axios from "axios";
import { defineComponent, ref, nextTick } from "vue";

export default defineComponent({
  props: {
    name: String,
    spa: String,
  },
  data() {
    return {
      sysPwd: "",
      pwd: "",
      pwShow: true,
      detailShow: false,
      commentData: [],
      getResult: "&emsp;",
      watermarkConfig: {
        content: "gg9453.com",
        font: {
          fontSize: 40,
          color: "rgba(0, 0, 0, 0.15)",
        },
        zIndex: 0,
        rotate: 36,
        gap: [40, 40],
        offset: [180,0]
      },
    };
  },
  methods: {
    selectLink() {
      axios
        .post("/php/spa_config.php", {
          action: "selectLink",
        })
        .then((res) => {
          var resPwd = res.data.find((e) => e.code === "pwd");
          this.sysPwd = resPwd.text;
          if (this.sysPwd == localStorage.getItem("sysPwd")) {
            this.pwShow = false;
            this.detailShow = true;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    selectComment(spa, name) {
      axios
        .post("/php/spa_table.php", {
          action: "selectComment",
          spa: spa,
          name: name,
        })
        .then((res) => {
          this.commentData = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    selectComment2(spa, name) {
      axios
        .post("/php/spa_table.php", {
          action: "selectComment2",
          spa: spa,
          name: name,
        })
        .then((res) => {
          this.commentData = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    doCheck() {
      localStorage.setItem("sysPwd", this.pwd);
      if (this.sysPwd == this.pwd) {
        this.pwShow = false;
        this.detailShow = true;
      } else {
        this.getResult = "密碼錯誤";
        setTimeout(() => {
          this.getResult = "&emsp;";
        }, 3000);
      }
    },
  },
  created: function() {
    this.$nextTick(() => {
      document.onselectstart  = function(){
        return false;
      }
      document.body.oncopy = function(){
        return false;
      }
    });
  },
  mounted: function () {
    //this.selectLink();
    this.pwShow = false;
    this.detailShow = true;

    var location = window.location.origin;
    if(location.indexOf("9cz8s") > -1){
      this.watermarkConfig.content = "9cz8s.gg9453.com";
    } else if(location.indexOf("g1fxk") > -1){
      this.watermarkConfig.content = "g1fxk.gg9453.com";
    } else if(location.indexOf("opdh3") > -1){
      this.watermarkConfig.content = "opdh3.gg9453.com";
    }  else if(location.indexOf("1azxs") > -1){
      this.watermarkConfig.content = "1azxs.gg9453.com";
    }
  },
  watch: {
    spa: function (val, oldVal) {
      this.commentData.splice(0);
      if("spa_08" == val){
        var spa1 = "('spa_08','spa_11')";
        this.selectComment2(spa1, this.name);
      } else{
        this.selectComment(val, this.name);
      }
    },
    name: function (val, oldVal) {
      this.commentData.splice(0);
      if("spa_08" == this.spa){
        var spa2 = "('spa_08','spa_11')";
        this.selectComment2(spa2, val);
      } else{
        this.selectComment(this.spa, val);
      }
      
    },
  },
});
